var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "revising-editor" },
    [
      _c(_setup.ManuscriptList, {
        attrs: {
          manuscripts: _setup.manuscriptListItems,
          "active-manuscript-key": _setup.activeManuscriptKey,
        },
        on: { "manuscript-click": _setup.onManuscriptClick },
      }),
      _c("div", { staticClass: "revising-editor__content" }, [
        _c(
          "div",
          { staticClass: "revising-editor__content-header" },
          [
            !_setup.isAiReviseMode
              ? _c(
                  "button",
                  {
                    staticClass: "revising-editor__execute-button",
                    attrs: { type: "button", disabled: !_setup.isRulesReady },
                    on: { click: _setup.onClickExecute },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _setup.t(
                            "proofreadingReviseManuscriptPage.summary.changeItems"
                          )
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _setup.isAiReviseMode && _setup.enabledAiCheckLabels.length > 0
              ? _c("p", { staticClass: "revising-editor__ai-checks" }, [
                  _vm._v(" " + _vm._s(_setup.aiResultSummaryText) + " "),
                ])
              : _vm._e(),
            _c(_setup.RevisingEditorSaveActions, {
              attrs: {
                "novel-id": _setup.props.novelId,
                "is-saving": _setup.isSavingWork,
                "is-applying": _setup.isApplyingToManuscript,
                "has-unsaved-changes": _setup.hasDirtyManuscripts,
                "show-save-completed": _setup.showTempSaveCompletedLabel,
                "apply-confirm-handler": _setup.onClickApplyToManuscript,
              },
              on: { "save-click": _setup.onClickSave },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "revising-editor__content-body" },
          [
            _c(
              "div",
              { staticClass: "revising-editor__content-body-editor" },
              [
                _setup.loading
                  ? _c(
                      "div",
                      { staticClass: "revising-editor__editor-loading" },
                      [
                        _c(_setup.LoadingSpinner, {
                          attrs: {
                            size: "medium",
                            variant: "inline",
                            text: _setup.t(
                              "proofreadingReviseManuscriptPage.loadingManuscript"
                            ),
                          },
                        }),
                      ],
                      1
                    )
                  : _setup.activeManuscriptKey != null
                  ? _c(_setup.LexicalEditor, {
                      key: _setup.activeManuscriptKey,
                      ref: "lexicalEditorRef",
                      attrs: { content: _setup.activeManuscriptContent },
                      on: {
                        "mark-click": _setup.onMarkClick,
                        "content-change": _setup.onEditorContentChange,
                        "editor-ready": _setup.onEditorReady,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(_setup.IssueList, {
              ref: "issueListRef",
              attrs: {
                "issue-categories": _setup.displayIssueCategories,
                "manuscript-keys": _setup.manuscriptOrderKeys,
              },
              on: {
                "issue-click": _setup.onIssueClick,
                "issue-apply": _setup.onIssueApply,
                "issue-revert": _setup.onIssueRevert,
                "issue-reject-toggle": _setup.onIssueRejectToggle,
                "issue-hover": _setup.onIssueHover,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }